module.exports = __webpack_public_path__ + "static/media/mitsubishi-pin.8e6a37b7.svg";